import classNames from 'classnames/bind';

import Styles from './styles.scss';

const cx = classNames.bind(Styles);

const ComingSoon = ({ position }) => <div className={`${cx('coming-soon', { [position]: position })} coming-soon ${position}`}>Coming Soon</div>;

export default ComingSoon;
